import '.bl{flex-shrink:0;}.ssr-plugin'
import '.c9{width:20rem;}.ssr-plugin'
import '.ar{border:var(--border-subtle);}.ssr-plugin'
import '.b4{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.ac{border-radius:1.25rem;}.ssr-plugin'
import '.bd{padding:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ca{gap:4rem;}.ssr-plugin'
import '.c1{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="bl c9 ar b4 ac bd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="d ca c1"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
